﻿import React from "react";
import PropTypes from "prop-types";
import {
  ResultError,
  ResultInfo,
  ResultSubtract,
  ResultSuccess,
} from "@/ImageRepo";
import ShepButton from "./ShepButton";
import { Dialog, DialogTitle, DialogContent, Box } from "@mui/material";
import "./ShepResults.css";

const ShepResults = ({
  open,
  onClose,
  state,
  title,
  message,
  onPrimaryClick,
  onSecondaryClick,
  primaryLabel,
  secondaryLabel,
}) => {
  const renderIcon = () => {
    switch (state) {
      case "Success":
        return <ResultSuccess width="65" height="65" />;
      case "Warning":
        return <ResultSubtract width="65" height="65" />;
      case "Error":
        return <ResultError width="65" height="65" />;
      case "Info":
        return <ResultInfo width="65" height="65" />;
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="shep-results-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className="dialog-title">
        <div className="icon-container">{renderIcon()}</div>
        <h2 className="title">{title}</h2>
      </DialogTitle>
      <DialogContent className="dialog-content non-scrollable-content">
        <p className="message">{message}</p>
      </DialogContent>

      <Box className="button-container">
        {onSecondaryClick ? (
          <>
            <ShepButton
              size="small"
              variant="secondary"
              onClick={onSecondaryClick}
            >
              {secondaryLabel}
            </ShepButton>
            <ShepButton size="small" variant="primary" onClick={onPrimaryClick}>
              {primaryLabel}
            </ShepButton>
          </>
        ) : (
          <ShepButton size="small" variant="primary" onClick={onPrimaryClick}>
            {primaryLabel}
          </ShepButton>
        )}
      </Box>
    </Dialog>
  );
};

ShepResults.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  state: PropTypes.oneOf(["Success", "Warning", "Error", "Info"]).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onPrimaryClick: PropTypes.func.isRequired,
  onSecondaryClick: PropTypes.func,
  primaryLabel: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.string,
};

export default ShepResults;
